import React from 'react'
import { User, Clock } from 'lucide-react'
import { formatTimestamp } from '../../utils/formatTime'

const SpeakerSegment = ({ 
  segment, 
  isHighlighted = false, 
  onClick,
  className = '' 
}) => {
  const getSpeakerColor = (speakerId) => {
    // 为不同说话者生成不同颜色
    const colors = [
      'text-blue-600 bg-blue-50 border-blue-200',
      'text-green-600 bg-green-50 border-green-200',
      'text-purple-600 bg-purple-50 border-purple-200',
      'text-orange-600 bg-orange-50 border-orange-200',
      'text-pink-600 bg-pink-50 border-pink-200',
      'text-indigo-600 bg-indigo-50 border-indigo-200'
    ]
    
    // 根据说话者ID生成一个稳定的索引
    const speakerNumber = parseInt(speakerId.replace(/\D/g, '')) || 1
    return colors[(speakerNumber - 1) % colors.length]
  }

  const speakerColorClass = getSpeakerColor(segment.speaker_id)

  return (
    <div 
      className={`
        border-l-4 pl-4 py-3 cursor-pointer transition-all duration-200
        ${isHighlighted ? 'bg-yellow-50 border-l-yellow-400' : 'border-l-gray-200 hover:border-l-gray-300'}
        ${className}
      `}
      onClick={() => onClick?.(segment)}
    >
      {/* 说话者和时间信息 */}
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center space-x-2">
          <div className={`flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium border ${speakerColorClass}`}>
            <User className="h-3 w-3" />
            <span>{segment.speaker_id}</span>
          </div>
          
          {segment.confidence && (
            <span className="text-xs text-gray-500">
              置信度: {Math.round(segment.confidence * 100)}%
            </span>
          )}
        </div>

        <div className="flex items-center space-x-1 text-xs text-gray-500">
          <Clock className="h-3 w-3" />
          <span>
            {formatTimestamp(segment.start_time)} - {formatTimestamp(segment.end_time)}
          </span>
        </div>
      </div>

      {/* 转录文本 */}
      <div className="text-gray-900 leading-relaxed">
        {segment.text}
      </div>
    </div>
  )
}

export default SpeakerSegment